import React, { useState } from "react";
import ReactDom from "react-dom";
import { toast } from "react-toastify";
import styles from "./saveFilterModal.module.css";
import Button from "../../button/button";
import { useInstitution } from "../../../context/InstitutionContext";
import { createSavedFilter } from "../../../services/finance";

const SaveFilterModal = ({ onClose, onFilterSaved, filterData }) => {
  const { institution } = useInstitution();
  const [filterName, setFilterName] = useState("");
  const [filterDescription, setFilterDescription] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSaveFilter = async () => {
    if (!filterName.trim()) {
      toast.error("Por favor, informe o nome do filtro");
      return;
    }

    if (!filterData) {
      toast.error("Nenhum filtro para salvar");
      return;
    }

    // Validação diferente dependendo do tipo de filtro
    const isConsolidatedDataFilter = filterData.filterGroups !== undefined;
    const isFinanceFilter = filterData.source === "Financeiro";
    const isEducationFilter = filterData.source === "Acadêmico";
    const isRegulatoryFilter = filterData.source === "Regulatorio";

    if (isConsolidatedDataFilter && filterData.filterGroups.length === 0) {
      toast.error("Nenhum filtro para salvar");
      return;
    }

    if (!isConsolidatedDataFilter && !isFinanceFilter && !isEducationFilter && !isRegulatoryFilter) {
      toast.error("Formato de filtro inválido");
      return;
    }

    try {
      setSaving(true);

      // Determinar qual tabela usar baseado no tipo de filtro
      let tables = ["Turnover"]; // Default para consolidatedData
      
      if (isFinanceFilter) {
        tables = ["Finance"];
      } else if (isEducationFilter) {
        tables = ["Education"];
      } else if (isRegulatoryFilter) {
        tables = ["Regulatory"];
      }

      await createSavedFilter({
        institutionId: institution.id,
        name: filterName.trim(),
        description: filterDescription.trim(),
        tables: tables,
        filter: filterData
      });
      onFilterSaved();
      onClose();
    } catch (error) {
      console.error("Erro ao salvar filtro:", error);
      toast.error("Erro ao salvar filtro. Tente novamente.");
    } finally {
      setSaving(false);
    }
  };

  return ReactDom.createPortal(
    <div className={styles.modalBackdrop} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3>Salvar Filtro</h3>
          <button className={styles.closeButton} onClick={onClose}>
            ×
          </button>
        </div>

        <p>Salve o filtro atual para reutilizá-lo posteriormente.</p>

        <div className={styles.formGroup}>
          <label htmlFor="filter-name">Nome do Filtro *</label>
          <input
            id="filter-name"
            type="text"
            placeholder="Ex: Modalidades Híbridas e EAD - Pagos"
            value={filterName}
            onChange={(e) => setFilterName(e.target.value)}
            className={styles.input}
            maxLength={100}
          />
        </div>

        <div className={styles.formGroup}>
          <label htmlFor="filter-description">Descrição</label>
          <textarea
            id="filter-description"
            placeholder="Descreva o que este filtro faz..."
            value={filterDescription}
            onChange={(e) => setFilterDescription(e.target.value)}
            className={styles.textarea}
            rows={4}
            maxLength={500}
          />
        </div>

        <div className={styles.modalActions}>
          <Button
            text="Cancelar"
            variation="secondary"
            size="medium"
            onClick={onClose}
            styling={{
              padding: "8px 20px",
              fontSize: "13px"
            }}
          />
          <Button
            text={saving ? "Salvando..." : "Salvar Filtro"}
            variation="primary"
            size="medium"
            onClick={handleSaveFilter}
            disabled={saving || !filterName.trim()}
            styling={{
              padding: "8px 20px",
              fontSize: "13px"
            }}
          />
        </div>
      </div>
    </div>,
    document.getElementById("modal-root")
  );
};

export default SaveFilterModal;

